"use client";

import React from "react";
import { ArrowRight, Loader, Check } from "lucide-react";
import { FormProvider, useWvcForm } from "@/integrations/forms/FormProvider";
import { Form, FormField, FormItem, FormLabel, FormControl, FormMessage, FormDescription } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
function InnerCircleForm() {
  const {
    isSubmitting,
    isSubmitted,
    submitError,
    successMessage,
    handleSubmit,
    control
  } = useWvcForm();
  if (isSubmitted && !submitError) {
    return <div className="flex flex-col items-center justify-center py-12 text-center animate-in fade-in duration-500">
        <div className="size-12 rounded-lg bg-primary/20 text-primary flex items-center justify-center mb-4">
          <Check className="size-6" />
        </div>
        <h3 className="text-xl font-default font-semibold mb-2 text-foreground">Subscription Confirmed</h3>
        <p className="text-muted-foreground font-mono text-sm">{successMessage}</p>
      </div>;
  }
  const inputStyles = "border-x-0 border-t-0 border-b border-border rounded-none shadow-md focus-visible:ring-0 focus-visible:border-primary px-0 bg-transparent h-12 text-base font-mono placeholder:text-muted-foreground/50 transition-all duration-300";
  return <Form onSubmit={handleSubmit} className="space-y-8 text-left w-full max-w-md mx-auto">
      <div className="space-y-6">
        <FormField control={control} name="full_name" render={({
        field
      }) => <FormItem>
              <FormControl>
                <Input placeholder="Full Name" className={inputStyles} {...field} />
              </FormControl>
              <FormMessage className="text-destructive font-mono text-xs" />
            </FormItem>} />

        <FormField control={control} name="email" render={({
        field
      }) => <FormItem>
              <FormControl>
                <Input type="email" placeholder="Email Address" className={inputStyles} {...field} />
              </FormControl>
              <FormMessage className="text-destructive font-mono text-xs" />
            </FormItem>} />

        <FormField control={control} name="phone" render={({
        field
      }) => <FormItem>
              <FormControl>
                <Input type="tel" placeholder="Phone Number (Optional)" className={inputStyles} {...field} />
              </FormControl>
              <FormDescription className="text-xs font-mono mt-1 text-muted-foreground/70">Optional – for urgent financial alerts</FormDescription>
              <FormMessage className="text-destructive font-mono text-xs" />
            </FormItem>} />

        <FormField control={control} name="agree_updates" render={({
        field
      }) => <FormItem className="flex flex-row items-start space-x-3 space-y-0 pt-4">
              <FormControl>
                <input type="checkbox" className="mt-1 size-4 shrink-0 rounded-sm border-border bg-muted text-primary focus:ring-primary accent-primary cursor-pointer" checked={field.value} onChange={field.onChange} disabled={field.disabled} name={field.name} ref={field.ref} onBlur={field.onBlur} />
              </FormControl>
              <div className="space-y-1 leading-none">
                <FormLabel className="font-normal text-sm text-foreground cursor-pointer">
                  I agree to receive monthly financial insights
                </FormLabel>
                <FormDescription className="text-xs font-mono text-muted-foreground">
                  Join our network of informed entrepreneurs
                </FormDescription>
                <FormMessage className="text-destructive font-mono text-xs" />
              </div>
            </FormItem>} />
      </div>

      {submitError && <div className="p-4 bg-destructive/10 border border-destructive/20 rounded-md text-destructive text-sm text-center font-mono">
          {submitError}
        </div>}

      <Button type="submit" disabled={isSubmitting} className="w-full h-12 rounded-md group text-base font-default font-bold tracking-tight bg-gradient-to-r from-secondary to-primary hover:opacity-90 transition-opacity shadow-lg">
        {isSubmitting ? <>
            <Loader className="animate-spin mr-2 size-5" />
            Processing...
          </> : <>
            Join Now
            <ArrowRight className="ml-2 size-5 transition-transform group-hover:translate-x-1" />
          </>}
      </Button>
    </Form>;
}
export default function StayInformed() {
  return <section data-section-id="223869" id="stay-informed" className="py-24 md:py-32 dark bg-background text-foreground flex items-center justify-center relative overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-secondary/10 via-background to-primary/10 opacity-50 pointer-events-none" />
      <div className="container px-4 text-center relative z-10">
        <div className="max-w-2xl mx-auto mb-12">
          <h2 className="text-4xl md:text-5xl font-default font-bold tracking-tighter mb-4 text-foreground">
            Stay Informed
          </h2>
          <p className="text-muted-foreground text-lg font-mono">
            Financial wisdom, delivered monthly.
          </p>
        </div>

        <FormProvider formKey="newsletter_signup_resources" formId="newsletter_signup_resources" sectionName="stay-informed" defaultValues={{
        full_name: "",
        email: "",
        phone: "",
        agree_updates: false
      }} validationRules={{
        full_name: {
          required: "Full Name is required"
        },
        email: {
          required: "Email is required",
          pattern: {
            value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
            message: "Please enter a valid email address"
          }
        },
        phone: {},
        agree_updates: {
          required: "You must agree to join the network"
        }
      }} submitText="Join Now" successMessage="Welcome to LEDGER. Your first insight report is on its way.">
          <InnerCircleForm />
        </FormProvider>
      </div>
    </section>;
}